
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { emptyToLine, splitThousands } from "@common/src/utils/common";
import dayjs from "dayjs";
import BtnRadio from "@/components/scope/btn-radio.vue";
import FilterBar from "./components/filter-bar.vue";
import echarts from "echarts";
import t from "@common/src/i18n/t";
import { addCurrencyUnit } from "@common/src/utils/tools";
import TextTips from "@common/src/components/scope/text-tips/index.vue";

const common_statement = namespace("common_statement");
const statement = namespace("statement");
const base = namespace("base");
const management = namespace("management");
const serviceItem = namespace("service-item");
const parts = namespace("parts");
@Component({
  components: { BtnRadio, FilterBar, TextTips },
  filters: {}
})
export default class Statement extends Vue {
  @statement.Action getTurnOverAnalysisModel;
  @base.Action getDictionaryList;
  @management.Action getStoreList;
  @serviceItem.Action getServiceItemList;
  @common_statement.Action queryReceiptReportDetail;
  @parts.Action getPartsList;
  addCurrencyUnit = addCurrencyUnit;
  dayjs = dayjs;
  splitThousands = splitThousands;
  emptyToLine = emptyToLine;
  searchForm: any = {
    receiptType: "",
    reportType: "1", // 时间范围类型, date-按日,month-按月
    receiptTimeFrom: "", // 开始时间 格式: 按日为yyyyMMdd, 按月为yyyyMM
    receiptTimeTo: "" // 结束时间 格式: 按日为yyyyMMdd, 按月为yyyyMM
  };
  contentList: any = [];

  mounted() {
    this.init();
  }
  get searchList() {
    let timeRow = [
      {
        label: t("v210831.time-frame"),
        type: "select-view",
        value: this.queryBody?.reportType || "",
        prop: "reportType",
        selectList: [
          {
            value: "1",
            label: t("v210831.query-by-day"),
            itemValue: this.queryBody?.receiptTimeFrom
              ? [this.queryBody.receiptTimeFrom, this.queryBody.receiptTimeTo]
              : "",
            itemType: "daterange",
            itemProp: "dateValue",
            itemValueFormat: "yyyyMMdd"
          },
          {
            value: "2",
            label: t("v210831.query-by-month"),
            itemValue: this.queryBody?.receiptTimeFrom
              ? [this.queryBody.receiptTimeFrom, this.queryBody.receiptTimeTo]
              : "",
            itemType: "monthrange",
            itemProp: "dateValue",
            itemValueFormat: "yyyyMM"
          }
        ]
      }
    ];
    return [
      ...timeRow,
      {
        label: t("finance.proceeds-type"),
        type: "select",
        value: this.queryBody?.receiptType || "",
        prop: "receiptType",
        placeholder: t("v210831.please-select"),
        selectList: this.receiptTypeList
      }
    ];
  }
  myChart: any = undefined;
  receiptTypeList: any = [];
  init() {
    this.getDictionaryList("receipt_type").then(data => {
      this.receiptTypeList = data;
    });

    this.myChart = echarts.init(document.querySelector(".charts-el"));
    // this.draw();
  }

  reportData: any = {};
  queryReportDetail() {
    this.queryReceiptReportDetail(this.searchForm).then(data => {
      const series = [];
      const valueArr = [];
      const xAxisData = [];
      data.data?.list.forEach((item, index) => {
        item.receiptDetials.forEach((itemDetail, detailIndex) => {
          if (index === 0) {
            series.push({
              name: itemDetail.receiptTypeDesc,
              type: "bar",
              stack: "Ad",
              barWidth: 36,
              emphasis: {
                focus: "series"
              },
              data: []
            });
            valueArr[detailIndex] = [];
          }
          valueArr[detailIndex][index] = Number(itemDetail.receiptAmount);
        });
        if (this.searchForm.reportType === "1") {
          xAxisData.push(item.receiptTime.slice(-5));
        } else {
          xAxisData.push(item.receiptTime);
        }
      });
      series.forEach((seriesItem, index) => {
        seriesItem.data = valueArr[index];
      });
      console.log(series, valueArr);
      this.draw(series, xAxisData);
    });
  }
  selfData: any = [];
  handleSearch(data) {
    this.mix_pageNum = 1;
    data.forEach(item => {
      if (item.prop) {
        if (item.type === "select-view") {
          item.selectList.forEach(val => {
            if (val.value === item.value) {
              if (val.itemProp === "dateValue") {
                this.searchForm.receiptTimeFrom = val.itemValue[0] || "";
                this.searchForm.receiptTimeTo = val.itemValue[1] || "";
              } else {
                this.searchForm[val.itemProp] = val.itemValue;
              }
            }
          });
          if (item.prop === "reportType") {
            this.searchForm[item.prop] = item.value;
          }
        } else {
          this.searchForm[item.prop] = item.value;
        }
      }
    });
    if (this.searchForm.reportType === "1") {
      // 天数不超过31天
      const start = this.searchForm.receiptTimeFrom;
      const end = this.searchForm.receiptTimeTo;
      if (dayjs(start).add(31, "day").startOf("day").isBefore(dayjs(end))) {
        return this.$message.error(t("v213.the-selected-range-can-not-exceed-31-days"));
      }
    } else {
      // 月份不超过12个月
      const start = this.searchForm.receiptTimeFrom;
      const end = this.searchForm.receiptTimeTo;
      if (dayjs(start).add(12, "month").startOf("month").isBefore(dayjs(end))) {
        return this.$message.error(t("v213.the-selected-range-can-not-exceed-12-months"));
      }
    }
    this.selfData = data;
    this.queryReportDetail();
  }
  draw(series, xAxisData) {
    let options = {
      color: ["#2278F5", "#599AFA", "#00B478", "#5FC71A", "#FEBC00", "#FF9900", "#FE7000"],
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "shadow"
        },
        formatter: params => {
          let str = `${params[0].name}<br>`;
          console.log(222, params);
          let totalAmount = 0;
          str += params
            .map(item => {
              totalAmount += item.value;
              return `<div style="display:flex;justify-content:space-between"><span style="margin-right:5px">${item.marker} ${item.seriesName}:</span><span>${item.value}</span></div>`;
            })
            .join("");
          str += `<span style="display:flex;border-bottom: #BFBFBF 1px solid;margin:5px 0px"></span>`;
          str += `<div style="display:flex;justify-content:space-between"><span style="padding-left:18px">${t(
            "v213.receipt-all"
          )}:</span> <span>${totalAmount.i18nToFixed()}</span></div>`;
          return str;
        }
      },
      legend: {
        show: true,
        bottom: 20
      },
      grid: {
        top: "50px",
        left: "3%",
        right: "4%",
        bottom: "80px",
        containLabel: true
      },
      xAxis: [
        {
          type: "category",
          data: xAxisData,
          axisLabel: {
            textStyle: {
              //文字样式
              color: "#8C8C8C",
              fontSize: "12"
            },
            rotate: series?.[0]?.data.length > 20 ? 40 : 0 //倾斜度可以根据需求设置
          }
        }
      ],
      yAxis: [
        {
          axisTick: { show: false },
          type: "value"
        }
      ],
      series: series
    };
    this.myChart.setOption(options, true);
    window.addEventListener("resize", () => {
      this.myChart.resize();
    });
  }

  get queryBody() {
    if (this.$route.query.searchForm) {
      return JSON.parse(this.$route.query.searchForm as string);
    } else {
      return null;
    }
  }
}
